// extracted by mini-css-extract-plugin
module.exports = {"root":"Notes_root__1eMFw","notes":"Notes_notes__FLqDr","note":"Notes_note__1RQaO","markdown":"Notes_markdown__yNVBq"};